package de.oevbs.kunde.kundenportal2

import de.oevbs.businesspartner.bpcrmservice2.common.model.LineOfBusiness
import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import dev.fritz2.core.Lens
import dev.fritz2.core.lensOf

object Formats {

    val trimString: Lens<String, String> = lensOf(
        parse = { it.trim() },
        format = { it }
    )

    val lowercase: Lens<String, String> = lensOf(
        parse = { it.trim().lowercase() },
        format = { it }
    )

    val partnerId: Lens<String, String> = lensOf(
        parse = { it.trim().trimStart('0') },
        format = { it }
    )

    val iban: Lens<String, String> = lensOf(
        parse = { it.replace(" ", "").uppercase() },
        format = {
            // Regex: Insert a space every 4 characters not immediately followed by a line-ending
            it.replace("....(?!$)".toRegex(), "$0 ")
        }
    )
}

/**
 * Wandelt einen [LineOfBusiness]-Wert in einen String für die Anzeige um
 *
 * @param lineOfBusinessSelected der zu wandelnde [LineOfBusiness]-Wert
 * @return einen [String] für die Anzeige, z.B. in einem Filter-SelectMenü
 */
fun lineOfBusinessToString(lineOfBusinessSelected: LineOfBusiness): String = when (lineOfBusinessSelected) {
    LineOfBusiness.Unbekannt -> "Alle Sparten"
    LineOfBusiness.FDLProdukte -> "Sparte: weitere Finanzprodukte"
    else -> "Sparte: ${lineOfBusinessSelected.title}"
}

/**
 * Formatiert die Optionen für ein ButtonToggleKupo, welches mit [CarContract]
 * verwendet wird, sodass Kennzeichen, Fahrzeugart und Vertragsnummer untereinander stehen.
 */
val carContractsButtonToggleFormat: (CarContract?) -> List<String> = { c ->
    if (c != null) {
        buildList {
            if (c.licencePlate.isNotBlank()) add(c.licencePlate) //   BS OV 1234
            if (c.branchGroup.isNotBlank()) add(c.branchGroup)   //      PKW
            add(c.contractNumberPm)                              //  808356780001
        }
    } else emptyList()
}